const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080';

const getAuthHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'Content-Type': 'application/json',
});

/**
 * List service content sections (admin).
 * @param {Object} params - Optional: service_id, page, limit
 */
const listSections = async (params = {}) => {
  const qs = new URLSearchParams();
  if (params.service_id) qs.append('service_id', params.service_id);
  if (params.page != null) qs.append('page', params.page);
  if (params.limit != null) qs.append('limit', params.limit);
  const url = `${API_URL}/api/v1/admin/service-content-sections${qs.toString() ? `?${qs}` : ''}`;
  const response = await fetch(url, { headers: getAuthHeaders() });
  return response.json();
};

/**
 * Get one section by id (admin).
 */
const getSectionById = async (id) => {
  const response = await fetch(`${API_URL}/api/v1/admin/service-content-sections/${id}`, {
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * Create a section (admin).
 * Body: service_id, header?, sub_header?, section_type (TEXT|IMAGE|VIDEO), content (object), background?, display_order?
 */
const createSection = async (body) => {
  const response = await fetch(`${API_URL}/api/v1/admin/service-content-sections`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return response.json();
};

/**
 * Update a section (admin). Only provided fields are updated.
 */
const updateSection = async (id, body) => {
  const response = await fetch(`${API_URL}/api/v1/admin/service-content-sections/${id}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(body),
  });
  return response.json();
};

/**
 * Soft-delete a section (admin).
 */
const deleteSection = async (id) => {
  const response = await fetch(`${API_URL}/api/v1/admin/service-content-sections/${id}`, {
    method: 'DELETE',
    headers: getAuthHeaders(),
  });
  return response.json();
};

/**
 * User API: get sections by service (read-only, no auth).
 * Returns non-deleted sections ordered by display_order, created_at.
 */
const getUserSectionsByService = async (serviceId) => {
  const response = await fetch(
    `${API_URL}/api/v1/user/service-content-sections/${serviceId}`
  );
  return response.json();
};

export {
  listSections,
  getSectionById,
  createSection,
  updateSection,
  deleteSection,
  getUserSectionsByService,
};
